import {motion, useAnimation} from 'framer-motion'
import {useEffect, useState} from 'react'
import {upTimer} from "utils";

export function Swipe({onChange}) {
  const
    [swiped, setSwiped] = useState(null),
    controls = useAnimation()

  useEffect(() => {
    if (swiped === null)
      return

    upTimer(() => {
      onChange([swiped])
    })
  }, [swiped])

  const
    handleDragEnd = (_, info) => {
      if (info.offset.x < -100) {
        setSwiped(0)
        controls.start({x: -200, opacity: 0, transition: {duration: 0.3}})
      } else if (info.offset.x > 100) {
        setSwiped(1)
        controls.start({x: 200, opacity: 0, transition: {duration: 0.3}})
      } else {
        controls.start({x: 0}) // Возврат в центр
      }
    },
    handleClick = (value) => {
      setSwiped(value)
      handleDragEnd(null, {offset: {x: value ? 101 : -101}})
    }

  return (
    <div className='swipe h-100 row wide' style={{alignItems: 'center', justifyContent: 'space-around'}}>
      <motion.img width={64} height={82} alt="" onClick={() => handleClick(0)}
        src={'/charisma/static/img/icon/swipe-no.svg'}
        animate={swiped === 0 ? {rotate: -30, opacity: 0.5} : {}}
      />

      <motion.div className="w-100 h-100 stack" style={{justifyContent: 'center'}}
        drag="x" dragConstraints={{left: 0, right: 0}}
        onDragEnd={handleDragEnd} animate={controls}
      />

      <motion.img width={68} height={102} alt="" onClick={() => handleClick(1)}
        src={'/charisma/static/img/icon/swipe-yes.svg'}
        animate={swiped === 1 ? {rotate: 30, opacity: 0.5} : {}}
      />
    </div>
  )
}